import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from "reactstrap";
import { RiErrorWarningLine } from "react-icons/ri";
import { withNamespaces } from "react-i18next";
import { useHistory } from "react-router-dom";

const CancelConfirmationModal = ({ t, isOpen, toggle }) => {
    const history = useHistory();

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>
                <div className="d-flex justify-content-start align-items-center">
                    <RiErrorWarningLine className="me-2 text-warning" size={22} />
                    {t('Confirm Exit')}
                </div>
            </ModalHeader>
            <ModalBody>
                <p className="mb-2 fw-semibold">
                    {t('Are you sure you want to leave?')}
                </p>
                <p className="text-muted mb-0">
                    {t('Your current selections will be discarded and the wizard will be canceled.')}
                </p>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    {t('Continue')}
                </Button>
                <Button 
                    color="primary"
                    onClick={() => history.push({
                        search: 'tab=kyb'
                    })}
                >
                    {t('Exit')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(
    CancelConfirmationModal
);
